module.exports = __webpack_public_path__ + "static/media/Vehicle.4a4abf1d.svg";